import { Component, OnInit, ViewChild } from '@angular/core';
import { Customer } from './customer-settings.model';
import { CustomerSettingsService } from './customer-settings.service';
import { DeletionDialogComponent } from 'src/app/layout/deletion-dialog/deletion-dialog.component';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerSettingsDialogComponent } from './customer-settings-dialog/customer-settings-dialog.component';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-customer-settings',
    templateUrl: './customer-settings.component.html',
    styleUrls: ['./customer-settings.component.scss'],
    imports: [MatDivider, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class CustomerSettingsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  parent: any;
  data: any;

  displayedColumns: string[] = [
    'id',
    'CompanyName',
    'FirstName',
    'LastName',
    'Email',
    'actions',
  ];
  tabledata: Customer[] = [];
  dataSource = new MatTableDataSource();
  customer: Customer;
  dialogConfig = new MatDialogConfig();

  searchForm: UntypedFormGroup;

  constructor(
    private snackbarService: SnackbarService,
    private customerSettingsService: CustomerSettingsService,
    private dialog: MatDialog,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.fetchData();
    this.searchForm = new UntypedFormGroup({
      filter: new UntypedFormControl(''),
    });
  }

  clearSearch(): void {
    this.searchForm.controls['filter'].setValue('');
    this.applyFilter();
  }

  applyFilter(): void {
    const filterValue = this.searchForm.value.filter;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  fetchData(): void {
    this.spinnerService.startSpinner();
    this.customerSettingsService.fetchCustomers().subscribe(
      (data: Customer[]) => {
        this.tabledata = data;

        this.dataSource = new MatTableDataSource(this.tabledata);
        this.dataSource.paginator = this.paginator;
        this.spinnerService.stopSpinner();
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  refreshTable(tabledata: Customer[]): void {
    this.dataSource = new MatTableDataSource(tabledata);
    this.dataSource.paginator = this.paginator;
  }

  deleteColumn(customer: Customer, index: number): void {
    const dialogRef = this.dialog.open(
      DeletionDialogComponent,
      this.dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.spinnerService.startSpinner();
        this.customerSettingsService.deleteCustomer(customer.id).subscribe(
          () => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openSuccess();
            this.fetchData();
          },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
      }
    });
  }

  openAdd(): void {
    const dialogRef = this.dialog.open(CustomerSettingsDialogComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((data: Customer) => {
      if (data) {
        this.submit(data);
      }
    });
  }

  openEdit(data: any, rowIndex?: number): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.width = '500px';
    const dialogRef = this.dialog.open(
      CustomerSettingsDialogComponent,

      dialogConfig
    );

    dialogRef.afterClosed().subscribe((data: Customer) => {
      if (data) {
        this.submit(data);
      }
    });
  }

  submit(customer: Customer): void {
    this.spinnerService.startSpinner();
    // wenn id vorhanden: update
    if (customer.id) {
      this.customerSettingsService.putCustomer(customer).subscribe(
        (data: Customer) => {
          for (let i = 0; i < this.tabledata.length; i++) {
            if (this.tabledata[i].id == data.id) {
              this.tabledata[i] = data;
              this.spinnerService.stopSpinner();
              this.snackbarService.openSuccess();
            }
          }

          this.refreshTable(this.tabledata);
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    } else {
      // wenn keine id vorhanden: create
      this.customerSettingsService.postCustomer(customer).subscribe(
        (data: Customer) => {
          this.tabledata.push(data);
          this.refreshTable(this.tabledata);
          this.spinnerService.stopSpinner();
          this.snackbarService.openSuccess();
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    }
  }
}
